import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://hxuvcshkbgtqnjjjpakl.supabase.co'
const supabaseKey = 'sb_publishable_TMtE3CQqzl51nnI47-j3nw_oeBaM-bn'

// 网络不稳定时（连接被重置/中断/Failed to fetch）自动重试
// 仅对幂等的 GET/HEAD 重试；POST/PATCH 等写操作不重试，避免重复提交
const IDEMPOTENT_METHODS = new Set(['GET', 'HEAD'])
// 服务端临时故障也值得重试
const RETRYABLE_STATUS = new Set([408, 429, 500, 502, 503, 504])
const MAX_RETRIES = 3

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

function getRequestMethod(input, init) {
  const initMethod = init && init.method
  const inputMethod = typeof input === 'object' && input !== null && input.method
  return String(initMethod || inputMethod || 'GET').toUpperCase()
}

// 判断是否为网络层错误（浏览器对连接重置/中断统一抛 TypeError: Failed to fetch）
function isNetworkError(error) {
  if (!error) return false
  const message = String(error.message || '').toLowerCase()
  return (
    error.name === 'TypeError' ||
    message.includes('failed to fetch') ||
    message.includes('networkerror') ||
    message.includes('network request failed') ||
    message.includes('load failed') ||
    message.includes('connection')
  )
}

async function resilientFetch(input, init = {}) {
  const method = getRequestMethod(input, init)
  const canRetry = IDEMPOTENT_METHODS.has(method)
  let lastError

  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    try {
      const response = await fetch(input, init)

      // 幂等请求遇到服务端临时故障时退避重试
      if (canRetry && RETRYABLE_STATUS.has(response.status) && attempt < MAX_RETRIES) {
        await sleep(500 * 2 ** attempt + Math.random() * 300)
        continue
      }

      return response
    } catch (error) {
      lastError = error
      // 网络层错误（连接重置、断网、DNS 失败等）才重试
      const retryableNetworkError = isNetworkError(error)
      if (!canRetry || !retryableNetworkError || attempt === MAX_RETRIES) {
        throw error
      }
      console.warn(`[supabase] 网络请求失败，${attempt + 1}/${MAX_RETRIES} 次重试中...`, error?.message)
      await sleep(600 * 2 ** attempt + Math.random() * 300)
    }
  }

  throw lastError
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  global: {
    fetch: resilientFetch
  }
})

// 供页面判断错误类型使用
export function isFetchNetworkError(error) {
  return isNetworkError(error)
}

export default supabase
